import React, { useState, memo, useRef } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { isMobile } from "react-device-detect";
import coverVideo from "../../../../../src/assets/images/test.png";
import { IconPlayFill } from "../../../../assets/icons";
import placeHolderimage from "../../../../assets/images/load-image-slider.jpg";
import useLazyLoad from "../../../components/LazyImage";

function SliderItem({ index, ItemData, amusementNameText }) {
  const screenWidth = window.innerWidth;
  const [ref, inView] = useLazyLoad({ threshold: 0.1 }); // وقتی 10% المان در viewport باشد

  const videoRef = useRef();

  const [stop, setStop] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const handleVideo = () => {
    setStop(!stop);
    if (stop == true) {
      videoRef.current.pause();
    } else videoRef.current.play();
  };

  return (
    <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">
      {ItemData?.gallery?.option === 1 ? (
        <div
          ref={ref}
          style={{
            position: "relative",
            width: "100%",
            height: isMobile ? "270px" : "300px",
          }}
          className="  pb-0"
        >
          <img
            src={placeHolderimage}
            data-src={
              process.env.REACT_APP_API_URL +
              ItemData?.gallery?.imageUrl +
              (isMobile ? "?width=340" : "?width=422")
            }
            altBot={amusementNameText}
            alt=""
            aria-hidden="true"
            className="rounded-3 mb-1 w-100"
            style={{
              display: isImageLoaded ? "none" : "block", // پس از لود عکس اصلی، مخفی می‌شود
              objectFit: "cover",
              height: "100%",
              backgroundColor: "#f5f5f5", // رنگ پس‌زمینه برای حالت Placeholder
            }}
          />
          {/* تصویر اصلی (فقط وقتی در viewport باشد لود می‌شود) */}
          {inView && (
            <>
              <img
                src={
                  process.env.REACT_APP_API_URL +
                  ItemData?.gallery?.imageUrl +
                  (isMobile ? "?width=340" : "?width=422")
                }
                alt={ItemData?.gallery?.imageAlt}
                className={`rounded-3 mb-1 w-100 ${
                  isImageLoaded ? "visible" : "invisible"
                }`}
                loading="lazy"
                onLoad={() => setIsImageLoaded(true)} // وقتی عکس لود شد، state را آپدیت می‌کند
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </>
          )}
        </div>
      ) : (
        <>
          <div
            key={index}
            id={ItemData?.gallery?.id}
            className=" w-100 h-100 p-0 "
            style={{
              height: isMobile ? "270px" : "300px",
              backgroundColor: "#000",
            }}
          >
            {!stop && (
              <div className="w-100 text-center play-video-icon">
                <IconPlayFill color="#fff" />
              </div>
            )}
            <div
              className="w-100"
              style={{ position: "absolute", zIndex: "2", height: "60%" }}
              onClick={() => {
                handleVideo();
              }}
            ></div>
            {!stop && (
              <div
                className="w-100 bg-dark opacity-50"
                style={{ position: "absolute", zIndex: "1", height: "100%" }}
              ></div>
            )}
            <video
              poster={coverVideo}
              ref={videoRef}
              controlsList="nodownload"
              onPause={() => {
                setStop(false);
              }}
              onPlay={() => {
                setStop(true);
              }}
              loading="lazy"
              width={!isImageLoaded ? 0 : ""}
              height={!isImageLoaded ? 0 : ""}
              onLoad={() => setIsImageLoaded(true)}
              src={process.env.REACT_APP_API_URL + ItemData?.gallery?.imageUrl}
              alt={ItemData?.gallery?.imageAlt}
              className="w-100 fullscreen h-100 "
              controls
            />
            <div
              style={
                !isImageLoaded
                  ? {}
                  : { position: "absolute", top: "45%", right: "35%" }
              }
            ></div>
          </div>
        </>
      )}
    </SkeletonTheme>
  );
}

export default memo(SliderItem);
